import React from 'react'
import { useCoachChat } from './CoachChatContext'
import { useTranslation } from '~/hooks/useTranslation'
import { getDarkModeLabelClass } from './coachDashboardStyles'

const DarkModeToggle = () => {
  const { isDarkMode, toggleDarkMode, getDarkModeClasses } = useCoachChat()
  const { t } = useTranslation('coach_chat')

  return (
    <label className="relative inline-flex cursor-pointer items-center gap-2">
      <span className={getDarkModeLabelClass(getDarkModeClasses)}>
        {t('coach_dashboard.dark_mode_label', 'Dark Mode:')}
      </span>
      <input
        type="checkbox"
        id="dark_mode_toggle"
        className="peer sr-only"
        checked={isDarkMode}
        onChange={toggleDarkMode}
      />
      <div
        className={`relative h-6 w-11 rounded-full transition-colors duration-200 ${getDarkModeClasses(
          isDarkMode ? 'bg-gray-600' : 'bg-[#cbced4]',
          'bg-gray-600',
        )}`}
      >
        <div
          className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white transition-transform duration-200 ease-in-out ${
            isDarkMode ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </div>
    </label>
  )
}

export default DarkModeToggle
